import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/customers')({
  component: CustomersLayout,
})

function CustomersLayout() {
  return (
    <div className='container mx-auto py-6'>
      <Outlet />
    </div>
  )
}
